export default __webpack_public_path__ + "static/media/LAS0210.34I-30561_-17612_0.aa4a3712.jpg";